export default "__VITE_ASSET__490ed06f__"